let ctx = null;
let master = null;
let hum = null;
let amb = null;
let music = null;
let bgmBus = null;
let bgmTimer = null;
let bgmNextChord = 0;
let bgmNextNote = 0;
let bgmIdx = 0;
let noiseBuf = null;
let muted = localStorage.getItem("labirinto-muted") === "1";

const VOLUME = 0.9;
const rnd = (a, b) => a + Math.random() * (b - a);

const env = (g, t, attack, peak, decay) => {
  g.gain.setValueAtTime(0.0001, t);
  g.gain.exponentialRampToValueAtTime(peak, t + attack);
  g.gain.exponentialRampToValueAtTime(0.0001, t + attack + decay);
};

const noise = (t, dur, type, freq, q, peak, attack = 0.004) => {
  const src = ctx.createBufferSource();
  src.buffer = noiseBuf;
  src.loop = true;
  const f = ctx.createBiquadFilter();
  f.type = type;
  f.frequency.value = freq;
  f.Q.value = q;
  const g = ctx.createGain();
  env(g, t, attack, peak, dur);
  src.connect(f).connect(g).connect(master);
  src.start(t, Math.random() * 1.5);
  src.stop(t + attack + dur + 0.05);
};

const tone = (t, type, freq, dur, peak, attack = 0.004, endFreq, out = master) => {
  const o = ctx.createOscillator();
  o.type = type;
  o.frequency.setValueAtTime(freq, t);
  if (endFreq) o.frequency.exponentialRampToValueAtTime(endFreq, t + attack + dur);
  const g = ctx.createGain();
  env(g, t, attack, peak, dur);
  o.connect(g).connect(out);
  o.start(t);
  o.stop(t + attack + dur + 0.05);
};

const startAmbience = () => {
  amb = ctx.createGain();
  amb.connect(master);
  hum = ctx.createGain();
  hum.gain.value = 0.022;
  const lp = ctx.createBiquadFilter();
  lp.type = "lowpass";
  lp.frequency.value = 280;
  [[50, "sawtooth", 1], [100, "sine", 0.6], [150, "sine", 0.25]].forEach(([f, type, v]) => {
    const o = ctx.createOscillator();
    o.type = type;
    o.frequency.value = f;
    const g = ctx.createGain();
    g.gain.value = v;
    o.connect(g).connect(lp);
    o.start();
  });
  lp.connect(hum).connect(amb);

  const room = ctx.createBufferSource();
  room.buffer = noiseBuf;
  room.loop = true;
  const rf = ctx.createBiquadFilter();
  rf.type = "lowpass";
  rf.frequency.value = 220;
  const rg = ctx.createGain();
  rg.gain.value = 0.035;
  const lfo = ctx.createOscillator();
  lfo.frequency.value = 0.07;
  const lg = ctx.createGain();
  lg.gain.value = 0.02;
  lfo.connect(lg).connect(rg.gain);
  lfo.start();
  room.connect(rf).connect(rg).connect(amb);
  room.start();
};

const startMusicBus = () => {
  music = ctx.createGain();
  music.connect(master);
  const echo = ctx.createDelay(1);
  echo.delayTime.value = 0.34;
  const fb = ctx.createGain();
  fb.gain.value = 0.32;
  const wet = ctx.createGain();
  wet.gain.value = 0.3;
  music.connect(echo);
  echo.connect(fb).connect(echo);
  echo.connect(wet).connect(master);
};

const pad = (t, freqs, dur, peak) => {
  const lp = ctx.createBiquadFilter();
  lp.type = "lowpass";
  lp.frequency.value = 1100;
  const g = ctx.createGain();
  g.gain.setValueAtTime(0.0001, t);
  g.gain.exponentialRampToValueAtTime(peak, t + 0.45);
  g.gain.setValueAtTime(peak, t + dur);
  g.gain.exponentialRampToValueAtTime(0.0001, t + dur + 0.9);
  lp.connect(g).connect(music);
  freqs.forEach((f) =>
    ["sine", "triangle"].forEach((type, i) => {
      const o = ctx.createOscillator();
      o.type = type;
      o.frequency.value = f;
      o.detune.value = i ? 5 : -3;
      o.connect(lp);
      o.start(t);
      o.stop(t + dur + 1);
    })
  );
};

const N = { A3: 220, B3: 246.94, C4: 261.63, D4: 293.66, E4: 329.63, F3: 174.61, G3: 196, A4: 440, B4: 493.88, C5: 523.25, D5: 587.33, E5: 659.25, F5: 698.46 };

const MELODY = [[0, "E5", 0.5], [0.42, "C5", 0.5], [0.84, "A4", 0.9], [1.32, "F5", 0.5], [1.74, "E5", 0.5], [2.16, "C5", 0.6], [2.64, "E5", 0.5], [3.06, "D5", 0.5], [3.48, "B4", 2.2]];
const CHORDS = [[0, ["A3", "C4", "E4"], 1.3], [1.3, ["F3", "A3", "C4"], 1.3], [2.6, ["G3", "C4", "E4"], 0.85], [3.45, ["G3", "B3", "D4"], 1.6]];

const ready = () => ctx && !muted && ctx.state === "running";

const BGM_CHORDS = [
  [73.42, 110, 174.61, 329.63],
  [58.27, 87.31, 146.83, 220],
  [98, 146.83, 233.08, 220],
  [55, 82.41, 146.83, 196],
];
const BGM_NOTES = [293.66, 329.63, 349.23, 440, 523.25, 587.33, 698.46];
const CHORD_LEN = 9;

const startBgmBus = () => {
  bgmBus = ctx.createGain();
  bgmBus.gain.value = 0;
  const lp = ctx.createBiquadFilter();
  lp.type = "lowpass";
  lp.frequency.value = 1800;
  bgmBus.connect(lp).connect(master);
  const echo = ctx.createDelay(2);
  echo.delayTime.value = 0.62;
  const damp = ctx.createBiquadFilter();
  damp.type = "lowpass";
  damp.frequency.value = 1400;
  const fb = ctx.createGain();
  fb.gain.value = 0.48;
  const wet = ctx.createGain();
  wet.gain.value = 0.45;
  lp.connect(echo);
  echo.connect(damp).connect(fb).connect(echo);
  echo.connect(wet).connect(master);
};

const softPad = (t, freqs, dur, peak) => {
  const lp = ctx.createBiquadFilter();
  lp.type = "lowpass";
  lp.frequency.value = 560;
  const g = ctx.createGain();
  g.gain.setValueAtTime(0.0001, t);
  g.gain.exponentialRampToValueAtTime(peak, t + 3);
  g.gain.setValueAtTime(peak, t + dur);
  g.gain.exponentialRampToValueAtTime(0.0001, t + dur + 3.5);
  lp.connect(g).connect(bgmBus);
  freqs.forEach((f) =>
    ["sine", "triangle"].forEach((type, i) => {
      const o = ctx.createOscillator();
      o.type = type;
      o.frequency.value = f;
      o.detune.value = i ? 7 : -4;
      o.connect(lp);
      o.start(t);
      o.stop(t + dur + 4);
    })
  );
};

const bell = (t, f, eerie) => {
  tone(t, "sine", f, 3.2, 0.05, 0.008, null, bgmBus);
  tone(t, "sine", f * 2.01, 1.2, 0.012, 0.005, null, bgmBus);
  if (eerie) tone(t, "sine", f * 1.006, 3.4, 0.035, 0.01, null, bgmBus);
};

const bgmTick = () => {
  if (!ready()) return;
  const now = ctx.currentTime;
  if (bgmNextChord < now) bgmNextChord = now + 0.1;
  while (bgmNextChord < now + 1.5) {
    softPad(bgmNextChord, BGM_CHORDS[bgmIdx % BGM_CHORDS.length], CHORD_LEN, 0.016);
    bgmIdx++;
    bgmNextChord += CHORD_LEN;
  }
  if (bgmNextNote < now) bgmNextNote = now + rnd(1, 3);
  while (bgmNextNote < now + 1.5) {
    const eerie = Math.random() < 0.08;
    bell(bgmNextNote, eerie ? 415.3 : BGM_NOTES[Math.floor(Math.random() * BGM_NOTES.length)], eerie);
    bgmNextNote += rnd(1.8, 4.8);
  }
};

export const sfx = {
  init() {
    if (!ctx) {
      const AC = window.AudioContext || window.webkitAudioContext;
      if (!AC) return;
      ctx = new AC();
      noiseBuf = ctx.createBuffer(1, ctx.sampleRate * 2, ctx.sampleRate);
      const data = noiseBuf.getChannelData(0);
      for (let i = 0; i < data.length; i++) data[i] = Math.random() * 2 - 1;
      master = ctx.createGain();
      master.gain.value = muted ? 0 : VOLUME;
      master.connect(ctx.destination);
      startAmbience();
      startMusicBus();
      startBgmBus();
      this.bgm(true);
      document.addEventListener("visibilitychange", () => (document.hidden ? ctx.suspend() : ctx.resume()));
    }
    if (ctx.state === "suspended" && !document.hidden) ctx.resume();
  },

  bgm(on) {
    if (!ctx) return;
    bgmBus.gain.setTargetAtTime(on ? 1 : 0, ctx.currentTime, on ? 1.2 : 0.6);
    if (on && !bgmTimer) {
      bgmNextChord = 0;
      bgmNextNote = 0;
      bgmTimer = setInterval(bgmTick, 300);
      bgmTick();
    }
    if (!on && bgmTimer) {
      clearInterval(bgmTimer);
      bgmTimer = null;
    }
  },

  get muted() {
    return muted;
  },

  setMuted(m) {
    muted = m;
    localStorage.setItem("labirinto-muted", m ? "1" : "0");
    if (master) master.gain.setTargetAtTime(m ? 0 : VOLUME, ctx.currentTime, 0.05);
  },

  step() {
    if (!ready()) return;
    const t = ctx.currentTime;
    noise(t, 0.05, "bandpass", rnd(450, 900), 1.2, 0.07);
    tone(t, "sine", rnd(75, 95), 0.045, 0.06);
  },

  land() {
    if (!ready()) return;
    const t = ctx.currentTime;
    noise(t, 0.1, "lowpass", 320, 0.8, 0.14);
    tone(t, "sine", 62, 0.09, 0.12, 0.003, 40);
  },

  creak() {
    if (!ready()) return;
    const t = ctx.currentTime;
    const dur = rnd(0.8, 1.1);
    const base = rnd(105, 155);
    const o = ctx.createOscillator();
    o.type = "sawtooth";
    o.frequency.setValueAtTime(base, t);
    for (let i = 1; i <= 7; i++) o.frequency.linearRampToValueAtTime(base * rnd(0.75, 1.5), t + (dur * i) / 7);
    const am = ctx.createGain();
    am.gain.value = 0.5;
    const lfo = ctx.createOscillator();
    lfo.type = "square";
    lfo.frequency.setValueAtTime(rnd(14, 20), t);
    lfo.frequency.linearRampToValueAtTime(rnd(28, 40), t + dur);
    const lg = ctx.createGain();
    lg.gain.value = 0.5;
    lfo.connect(lg).connect(am.gain);
    const bp = ctx.createBiquadFilter();
    bp.type = "bandpass";
    bp.frequency.value = rnd(800, 1100);
    bp.Q.value = 5;
    const g = ctx.createGain();
    g.gain.setValueAtTime(0.0001, t);
    g.gain.exponentialRampToValueAtTime(0.4, t + 0.08);
    g.gain.setValueAtTime(0.4, t + dur * 0.7);
    g.gain.exponentialRampToValueAtTime(0.0001, t + dur);
    o.connect(am).connect(bp).connect(g).connect(master);
    o.start(t);
    lfo.start(t);
    o.stop(t + dur + 0.05);
    lfo.stop(t + dur + 0.05);
  },

  keyTinkle(near, pan) {
    if (!ready()) return;
    const t = ctx.currentTime;
    const out = ctx.createStereoPanner ? ctx.createStereoPanner() : ctx.createGain();
    if (out.pan) out.pan.value = Math.max(-0.8, Math.min(0.8, pan));
    out.connect(amb);
    const peak = 0.007 + 0.013 * near;
    const f = rnd(2900, 3400);
    tone(t, "sine", f, 0.35, peak, 0.002, undefined, out);
    tone(t, "sine", f * 1.51, 0.2, peak * 0.6, 0.002, undefined, out);
    if (Math.random() < 0.5) {
      tone(t + 0.09, "sine", f * 1.06, 0.25, peak * 0.7, 0.002, undefined, out);
      tone(t + 0.09, "sine", f * 1.6, 0.15, peak * 0.4, 0.002, undefined, out);
    }
  },

  key() {
    if (!ready()) return;
    const t = ctx.currentTime;
    [1318.5, 1760, 2637].forEach((f, i) => tone(t + i * 0.07, "sine", f, 0.9, 0.06, 0.004));
    noise(t, 0.05, "highpass", 5000, 0.7, 0.05);
  },

  close() {
    if (!ready()) return;
    const t = ctx.currentTime;
    tone(t, "sine", 72, 0.32, 0.28, 0.004, 38);
    noise(t, 0.16, "lowpass", 420, 1, 0.18);
  },

  flicker(frames) {
    if (!ready()) return;
    const t = ctx.currentTime;
    const d = frames / 60;
    hum.gain.setTargetAtTime(0.004, t, 0.01);
    hum.gain.setTargetAtTime(0.022, t + d, 0.03);
    tone(t, "square", 100, d, 0.018, 0.002);
    noise(t, d, "highpass", 3000, 0.7, 0.02, 0.002);
  },

  chalk() {
    if (!ready()) return;
    const t = ctx.currentTime;
    noise(t, 0.07, "bandpass", rnd(2300, 2800), 1.4, 0.09);
    noise(t + 0.09, 0.09, "bandpass", rnd(2800, 3400), 1.4, 0.07);
  },

  gas() {
    this.bgm(false);
    if (!ready()) return;
    const t = ctx.currentTime;
    noise(t, 3, "highpass", 2400, 0.5, 0.13, 0.5);
    noise(t, 2.8, "bandpass", 650, 0.8, 0.09, 0.9);
    tone(t, "sine", 55, 3.2, 0.2, 0.9, 40);
    tone(t, "sawtooth", 58, 2.6, 0.03, 1.2, 44);
  },

  ambience(on) {
    if (amb) amb.gain.setTargetAtTime(on ? 1 : 0, ctx.currentTime, on ? 0.2 : 0.35);
  },

  thunder() {
    if (!ready()) return;
    const t = ctx.currentTime;
    music.gain.cancelScheduledValues(t);
    music.gain.setTargetAtTime(0, t, 0.03);
    noise(t, 0.35, "highpass", 1200, 0.4, 0.6, 0.002);
    noise(t, 0.18, "bandpass", 3200, 0.6, 0.35, 0.001);
    tone(t, "sine", 70, 1.2, 0.5, 0.005, 30);
    noise(t + 0.05, 3.8, "lowpass", 220, 0.7, 0.55, 0.12);
    noise(t + 0.7, 3, "lowpass", 150, 0.7, 0.4, 0.3);
    noise(t + 1.6, 2.4, "lowpass", 110, 0.7, 0.25, 0.4);
  },

  escape() {
    this.ambience(false);
    this.bgm(false);
    if (!ready()) return;
    music.gain.cancelScheduledValues(ctx.currentTime);
    music.gain.setValueAtTime(1, ctx.currentTime);
    const t = ctx.currentTime + 0.05;
    noise(t - 0.05, 1.4, "lowpass", 900, 0.6, 0.06, 0.5);
    for (const [at, n, d] of MELODY) {
      tone(t + at, "triangle", N[n], d, 0.11, 0.012, null, music);
      tone(t + at, "sine", N[n] * 2, d * 0.5, 0.025, 0.006, null, music);
    }
    for (const [at, notes, d] of CHORDS) pad(t + at, notes.map((n) => N[n]), d, 0.035);
  },
};
